export function searchElements(element, count){
    return new Promise((resolve, reject) => {
        let interval = setInterval(()=>{
            let search = [... document.querySelectorAll(element)];
            if ( search.length > 0 )
                resolve(search);
            if ( count <= 0 )
                // reject(new Error(`Element nie został znaleziony: ${element}`));
            count--;
        }, 1000);
    });
}